export enum ScreenEnumType {
  mobile = 640,
  desktop = 1024,
}
